// extracted by mini-css-extract-plugin
export default {"container":"ProgressionPage_container__DUFbt","title":"ProgressionPage_title__CC6+S","subtitle":"ProgressionPage_subtitle__dEf1R","cards":"ProgressionPage_cards__1KxnS"};